import React, { useEffect, useRef, useState } from "react";
import { Users, TrendingUp, Calendar, MapPin } from "lucide-react";
import api from "@/lib/api";

const ICONS = { customers: Users, success_rate: TrendingUp, years_experience: Calendar, cities: MapPin };
const LABELS = { customers: "Happy Customers", success_rate: "Success Rate %", years_experience: "Years Experience", cities: "Cities Covered" };

function Counter({ target }) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !started.current) {
        started.current = true;
        const duration = 1500;
        const steps = 40;
        const increment = target / steps;
        let current = 0;
        const timer = setInterval(() => {
          current += increment;
          if (current >= target) {
            setCount(target);
            clearInterval(timer);
          } else {
            setCount(Math.floor(current));
          }
        }, duration / steps);
      }
    }, { threshold: 0.3 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [target]);

  return <span ref={ref}>{count.toLocaleString()}+</span>;
}

export default function StatsCounter() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/site-settings").then((res) => setStats(res.data.stats)).catch(() => {});
  }, []);

  if (!stats) return null;

  return (
    <section data-testid="stats-counter-section" className="bg-[#1A1A1A] py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-2 sm:grid-cols-4 gap-8">
        {Object.entries(stats).map(([key, value]) => {
          const Icon = ICONS[key] || Users;
          return (
            <div key={key} data-testid={`stat-${key}`} className="text-center">
              <Icon size={26} className="text-[var(--brand-primary)] mx-auto mb-3" />
              <div className="font-heading text-3xl sm:text-4xl font-semibold text-white">
                <Counter target={value} />
              </div>
              <p className="text-xs sm:text-sm text-gray-400 mt-2 uppercase tracking-wide">{LABELS[key] || key}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
